import useAuth from '@rhg/libs/auth0/use-auth';
import { logger } from '@rhg/libs/logger';
import { queryKeys } from '@rhg/libs/react-query';
import {
    ppDataObject,
    JwtPayload,
    PartnerPortalData,
    getIsSamlUserToken,
} from '@rhg/utils/sso';
import { useQuery } from '@tanstack/react-query';
import { jwtDecode } from 'jwt-decode';
import { useEffect } from 'react';

export function useTokenData() {
    const { user, isLoading, getAccessTokenSilently } = useAuth();
    const { data, isFetched, isError, error, ...otherProps } = useQuery({
        queryKey: [queryKeys.tokenData],
        queryFn: async () => {
            return getTokenData(await getAccessTokenSilently());
        },
        enabled: !isLoading && !!user,
    });

    useEffect(() => {
        if (!isFetched) return;
        const partnerId = data?.tokenPartnerPortalData?.partner_id;
        const isSaml = data?.isSaml;
        if (isError) {
            logger.warn('sso - token error', {
                error: error?.message,
                isSaml,
                partnerId,
            });
        } else {
            logger.info('sso - token fetched', {
                isSaml,
                partnerId,
            });
        }
    }, [isFetched, isError, data, error?.message]);

    return {
        ...data,
        isFetched,
        isError,
        error,
        ...otherProps,
    };
}

export function getTokenData(token?: string) {
    if (!token) {
        return null;
    }
    const decodedToken = jwtDecode<JwtPayload>(token);
    const tokenPartnerPortalData = decodedToken[
        ppDataObject
    ] as PartnerPortalData;
    return {
        token,
        decodedToken,
        tokenPartnerPortalData,
        isSaml: getIsSamlUserToken(decodedToken),
    };
}
